import { UnifiedTheme, createUnifiedTheme, themes } from '@backstage/theme';
import { PaletteOptions } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    navigation?: {
      background: string;
      indicator: string;
      color: string;
      selectedColor: string;
      navItem: {
        hoverBackground: string;
      };
      submenu: {
        background: string;
      };
    };
    banner?: {
      info: string;
      error: string;
      text: string;
      link: string;
      closeButtonColor: string;
      warning: string;
    };
  }

  interface PaletteOptions {
    navigation?: {
      background: string;
      indicator: string;
      color: string;
      selectedColor: string;
      navItem: {
        hoverBackground: string;
      };
      submenu: {
        background: string;
      };
    };
    banner?: {
      info: string;
      error: string;
      text: string;
      link: string;
      closeButtonColor: string;
      warning: string;
    };
  }
}

const genPageTheme = (colors: string[], baseColor = '#1D0638') => {
  const gradientColors = colors.length === 1 ? [colors[0], colors[0]] : colors;
  const gradient = `linear-gradient(90deg,${baseColor}, ${gradientColors.join(', ')})`;
  const pattern = `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='1440' height='400' fill='none'%3e%3cg clip-path='url(%23a)'%3e%3cpath fill='url(%23b)' d='M450.04 0c10.71 8.42 21.41 16.85 32.13 25.25 3.72 2.91 7.5 5.74 11.26 8.61l-.72.96c-6.25-4.53-12.6-8.92-18.71-13.61-9.07-6.96-17.98-14.13-26.95-21.21h-91.01c14.24 9.55 28.48 19.1 42.72 28.66 1.34.9 2.62 1.87 3.45 3.77-1.23-.48-2.59-.76-3.67-1.46-15.21-9.91-30.38-19.88-45.55-29.85-.39-.26-.64-.74-.95-1.12h-30c11.63 7.92 23.26 15.83 34.88 23.75-.14.21-.27.43-.41.64-10.96-6.78-21.93-13.55-32.87-20.37-1.95-1.22-3.74-2.67-5.61-4.02H0v96c21.23-1.42 42.45-2.84 63.68-4.27l.09 1.35C42.51 94.39 21.26 95.69 0 97v54l35.01-7.05.21 1.05c-11.74 2.33-23.48 4.67-35.22 7v77c21.28-2.97 42.48-2.44 63.43 2.23 11.78 2.63 23.37 6.16 35.04 9.29-.12.46-.24.92-.36 1.37-3.44-.95-6.9-1.84-10.32-2.85-27.75-8.22-55.99-11.27-84.83-7.96-.97.11-1.98-.05-2.97-.08v105c8.79-1.65 17.77-2.62 26.33-5.06 27.23-7.76 54.14-16.65 81.47-24 32.98-8.87 66.29-16.46 100.34-20.16 1.57-.17 3.15-.19 4.72-.27.09.4.19.8.28 1.2-1.08.35-2.15.87-3.26 1.02-48.71 6.45-96.21 18.17-142.82 33.49-22.03 7.24-44.18 13.84-67.06 17.79v60h692.07c3.97-8.21 9.82-14.63 16.7-18.62-4.2 5.71-8.95 12.17-13.7 18.62h173.02c1.09-1.21 2.19-2.41 3.53-3.9-11.05-3.76-21.79-7.42-32.53-11.08.1-.32.2-.64.3-.97 11.27 3.32 22.54 6.64 34.07 10.04-.58 2.48-.97 4.19-1.37 5.9h84.01c-2.14-2.38-4.28-4.76-6.54-7.27 5.11.26 7.79 3.83 10.54 7.27h56.01c-2.58-.53-5.14-1.2-7.74-1.58-18.14-2.65-36.21-6.35-54.44-7.46-12.57-.77-24.52-3.48-36.67-5.86-.81-.16-2 0-2.39-.48-5.19-6.55-13.29-6.47-20.24-8.56-55.69-16.72-111.49-33.09-167.22-49.66-19.32-5.74-38.57-11.75-57.86-17.62-2.03-.62-4.08-1.13-6.32-1.33 6.65 5.64 14.05 10.39 17.19 19.33-2.99-2.6-6.15-5.04-8.94-7.85-5.57-5.6-11.46-10.21-19.44-12.38-10.91-2.97-21.5-7.11-32.28-10.61-1.36-.44-2.97-.09-4.48-.07l-.03.09c1.35.85 3.03 1.46 3.91 2.65 14.27 19.34 24.67 40.81 33.91 62.91-4.38-8.33-8.43-16.84-13.21-24.93-7.52-12.73-15.54-25.16-23.31-37.74-.53-.87-.84-1.87-1.22-2.84-.07-.04-.14-.09-.21-.13l.11-.12c-1.89-1.21-3.78-2.41-5.67-3.62.24-.58.47-1.15.71-1.73 1.63.18 3.33.13 4.89.58 83.97 24.19 167.97 48.24 251.85 72.75 31.64 9.24 62.92 19.78 95.61 24.79 24.68 3.78 49.44 6.98 74.16 10.46 1.45.21 2.87.67 4.31 1.01h398.9V0H450.04Zm239.23 335.84c26.14 8.37 52.24 16.88 78.35 25.37 8.99 2.92 17.96 5.91 26.94 8.87l-.38 1.21c-37.64-11.74-75.29-23.48-113.71-35.46 1.71 6.01 3.02 11.83 5.15 17.33.68 1.75 3.53 2.7 5.45 3.9 1.52.95 3.14 1.74 5.28 2.91-11.92-1.35-17.17-9.11-17.63-26.15 3.65.67 7.23.95 10.56 2.01l-.01.01Zm372.97-178.95c9.75 1.2 19.52 2.25 29.27 3.42 1.4.17 2.76.59 4.04 1.55-125.02-10.36-249.66-23.82-373.9-40.94v-2.3c2.17-.17 4.38-.67 6.52-.46 18.07 1.72 36.16 3.34 54.19 5.41 58.92 6.77 117.83 13.63 176.72 20.62 34.4 4.08 68.77 8.48 103.15 12.7h.01Zm-336.27-48.6c22.16-2.69 44.32-5.37 66.48-8.06.04.32.08.63.11.95-22.08 2.71-44.15 5.42-66.23 8.14-.12-.34-.24-.68-.36-1.03Zm189.02-.29c-10.12-.54-18.44-4.63-28.54-5.33-1.56-.11-3.09-.78-4.63-1.19-7.61-.03-15.22.04-22.83-.13-5.13-.12-10.25-.58-15.36-1.4 12.72.51 24.65.54 37.37 1.05 9.45.54 19.66 1.57 29.09 2.08 13.57.73 426.38 32.29 439.91 33.92 3 5-423.68-28.4-435-29h-.01Zm-82.56-23.7c20.93-2.79 42.52-2.86 63.81-2.65 7.55.07 14.2-.22 21.75.34 2.21-.04 80 4 99 5 4.86.26 48.93 2.47 48 3 .03.21-134.03-5.21-134-5-2.58-.16-9.52.08-12.1-.11-8.95.17-17.91.46-26.79-.23-32.87-2.54-65.14.95-97.3 7.52-29.03 5.93-58.22 11.08-87.31 16.76-7.63 1.49-15.12 3.66-22.96 4.48 11.42-3.09 22.7-6.93 34.29-9.13 37.78-7.15 75.52-14.92 113.6-20l.01.02Zm-224.75-9.97c2.17.75 4.36 1.44 6.5 2.27 28.49 11.08 57.68 9.93 87.11 5.08 4.42-.73 8.93-.91 13.39-1.35-24.28 3.53-48.42 11.97-73.43 6.47-11.59-2.55-22.72-7.18-34.06-10.86.17-.54.33-1.08.5-1.62l-.01.01Zm4.3 85.05c-4.71 5.75-9.41 11.5-14.12 17.25-.39-.29-.79-.58-1.18-.87 4.74-5.75 9.49-11.5 14.23-17.25.36.29.71.58 1.07.87ZM487.99 93.99c20.74 1.7 104.63 7.14 122.93 17.74-18.94-8.67-102.94-14.16-122.93-17.74Zm-118.05-6.78c.11.37.21.74.32 1.11-10.28 2.83-20.56 5.65-30.84 8.48-.27-.88-.53-1.76-.8-2.63 10.44-2.32 20.88-4.63 31.33-6.95l-.01-.01Zm-74.33-16.43c4.79-3.61 9.67-7.12 14.52-10.65.37-.33.75-.65 1.12-.98.26-.14.51-.29.77-.43 3.36-2.62 6.55-5.48 10.16-7.67 5.14-3.11 10.64-5.63 16.51-7.34-8.86 4.98-17.71 9.97-26.57 14.95-.25.2-.5.4-.75.59l-.12-.1s.12.1.11.09l-1.31.95-17.72 15.44c-.29-.28-.59-.55-.88-.83 1.38-1.35 2.63-2.87 4.15-4.02h.01ZM122.63 88.47l-23.28 1.41c0-.47-.02-.94-.03-1.41h23.33c4.73-.68 9.42-1.62 14.15-2 22.89-1.81 45.79-3.49 68.69-5.18 26.38-1.95 52.77-3.87 79.15-5.79.62-.05 1.24 0 1.86 0 .03.51.06 1.02.1 1.53-54.62 3.82-109.24 7.63-163.87 11.45h-.11l.01-.01Zm150.97 15.19c-2.38.83-5.27 2.37-8.32 2.81-18.72 2.72-37.48 5.14-56.22 7.77-13 1.82-25.98 3.81-39.14 4.67 13.8-2.27 27.58-4.6 41.39-6.78 15.47-2.44 31.01-4.46 46.41-7.25 5.12-.93 9.9-3.68 14.66-5.53.12.41.59 2.09 1.21 4.3l.01.01ZM146.27 214.88c-.02-.31-.05-.63-.07-.94 22.83 1.83 45.66 3.65 68.48 5.48-.05.65-.11 1.3-.16 1.96-22.75-2.16-45.5-4.33-68.25-6.49v-.01Zm44.09 108.58s-.06.01-.08.02c-.95.56-1.79 1.43-2.78 1.67-10.66 2.61-21.34 5.13-32.02 7.64-.56.13-1.18.02-1.9-.83l36.57-8.46c.05-.03.1-.07.15-.1l.02.02c.22-.03.44-.06.66-.1l27.54-5.82.33 1.77-28.17 4.11c-.11.02-.21.04-.32.07v.01Zm47-36.26c-4.4 1.04-5.88-.77-5.97-4.68-.31-14.45-.77-28.9-.77-43.35 0-8.76.72-17.53 1.12-26.29h1.63v73.25c7.74-1.21 13.94-2.18 20.13-3.16.07.48.13.96.2 1.45-5.46.89-10.98 1.5-16.35 2.77l.01.01Zm68.38-22.77c-1.38-5.7-2.76-11.4-4.15-17.1.38-.1.75-.19 1.13-.29 1.54 5.71 3.08 11.43 4.63 17.14-.54.08-1.07.16-1.61.25Zm16.23-100.79c-.64.93-2.33 1.14-3.53.6-1.72-.35-3.52-1.23-5.14-.98-19.1 3.02-35.92 11.49-51.99 21.85 7.72-7.49 16.43-13.55 26.26-17.88 21.3-9.38 43.9-13.28 66.88-15.14 9.27-.75 15.22-.92 24.53-1.11 1.57-.03 30 0 26 1-.06.16-48.85 2.82-64.22 4.45-6.79.72-14.15.45-18.81 7.2l.02.01Zm60.21 70.38c10.08-23.18 23.88-44.27 39.92-63.97-13.34 21.37-26.67 42.74-39.92 63.97ZM468 211.31c-.23-18.18-5.42-34.31-20.2-47.24 15.15 3.14 24.81 21.54 20.2 47.24Zm23.74-47.75c-1.37-22.22-4.37-44.05-11.86-65.11-8.84-24.86-23.58-44.58-48.06-55.91-11.56-5.35-23.97-6.81-36.52-6.64-10.86.14-21.71.97-32.79.78 2.78-.77 5.54-2.15 8.33-2.2 11.95-.22 24-.97 35.85.15 32.7 3.08 55.51 20.94 69.49 50.02 11.95 24.87 16.34 51.49 15.54 78.92l.02-.01ZM479.1 51.51c30.91.44 61.96-.79 92.25 7.76-15.22-1.81-30.4-4.1-45.67-5.29-15.49-1.21-31.07-1.32-46.58-2.47Zm73.94 64.46c17.12 1.22 34.15 2.75 50.23 9.79 5.69 2.49 7.56 6.21 7.24 12-.19-7.33-5.55-8.99-11.02-11.03-15.66-5.84-32.09-7.19-48.47-8.96-7.92-.86-38.11-4.2-46.02-5.77 8.6.41 39.46 3.37 48.04 3.98v-.01ZM566 201.99c-5.82 2.29-11.1 4.42-16.78 7.16-6.24 3.01-12.76 5.46-19.09 8.13-.97-2.02-1.58-3.28-2.19-4.55 6.11-3.07 12.1-6.31 18.31-9.07 2.04-.91 4.65-.46 6.98-.8 1.21-.18 2.84-.36 3.45-1.17 2.64-3.46 4.98-7.16 7.54-10.93h-16.64c-2.59.23-9.41 1.31-14.05 5.75-.8.77-2.53.56-4.44.92 6.04-11.41 34.19-13.34 44.57-7.39-.64 4.86-2.56 9.94-7.67 11.96l.01-.01Zm7.44-26.39c-6.14-.32-12.25-1.09-18.37-1.77-5.92-.66-44.16-3.11-50.07-3.84.06-.22-.06-1.78 0-2 17.7 1.58 67.91 6.16 84.93 7.67-5.02 0-10.77.24-16.49-.06Zm12.98 47.82c5.95 1.95 11.57 3.8 17.19 5.64-6.15-.44-12.83.63-17.19-5.64Zm11.82-17.83c22.51-31.93 50.7-56.55 88.47-68.78-36.66 13.7-63.58 39.9-88.47 68.78Zm310.32-40.26c-56.44-7.3-112.88-14.59-169.32-21.89.04-.49.09-.98.13-1.48 56.45 7.34 112.9 14.69 169.36 22.03-.06.44-.11.89-.17 1.33v.01Zm107.34 157.94c-25.75-3.06-51.51-6.12-77.26-9.19.11-.57.23-1.15.34-1.72l77.05 9.84c-.04.36-.09.71-.13 1.07Zm43.91-100.24c-7.05-7.39-13.96-14.91-21.22-22.09-2.52-2.49-5.63-4.88-8.93-6.02-15.89-5.5-31.97-10.49-47.91-15.83-4.06-1.36-5.41-.17-6.36 3.91-4.66 20.08-23.66 93.09-28.57 113.12-.3 1.23-.89 2.39-2.44 3.31 6.04-28.36 23.86-103.41 31.39-137.77.64-2.91-1.43-5.71-4.39-5.97-1.54-.14-3-.27-4.63-.3-28.93-.44-57.33-5.67-85.91-9.29-34.87-4.41-69.84-8.06-104.75-12.24-16.86-2.02-33.69-4.37-50.49-6.86-3.31-.49-4.64.36-5.12 3.42-.35 2.28-.86 4.53-1.34 7.06 2.2.92 4.23 1.78 6.76 2.84-7.94 1.76-7.87 1.78-10.34 9.84-10.28 33.47-21.9 66.43-36.99 98.09-1.13 2.36-2.34 4.68-4.03 8.04 72.8 14.17 143.58 33.55 214.13 54.29-8.08-1.54-16.28-2.6-24.21-4.69-32.85-8.68-65.52-18.05-98.45-26.42-26.8-6.81-53.88-12.5-80.82-18.78-4.33-1.01-8.54-2.5-13.49-3.97 17.98-37.92 33.15-76.1 44.39-116.31-2.14-.26-3.26-.48-4.38-.5-.94-.01-1.88.21-2.82.33-.2-.48-.41-.96-.61-1.45 1.23-.46 2.59-1.5 3.68-1.27 3.64.77 5-.69 5.9-4.09 2.25-8.46 2.4-8.38 10.87-7.44 44.54 4.97 89.1 9.74 133.6 14.98 22.5 2.65 44.85 6.52 67.35 9.12 14.54 1.68 29.22 2.1 43.85 2.97 6.22.37 6.91 1.08 6.11 7.47-.21 1.66-.5 3.32-.85 4.96-1.97 9.11-2.08 8.63 6.46 11.42 15.99 5.21 31.83 10.87 47.72 16.39 1.24.43 2.62.96 3.5 1.87 8.38 8.7 16.66 17.5 24.96 26.27l-1.61 1.58-.01.01Zm205.12 133.41-179.29-20.22.3-2.62c59.73 7.02 279.32 33.39 339.05 40.4l-160.06-17.56Zm73.82-101.46c-7.37-.78-248.74-25.56-256.1-26.34.02-.22.04-1.42.06-1.64 7.52.63 249.05 26.23 256.57 26.87-.18.37-.35.74-.53 1.11Zm38.12 3.66c-6.22-.61-12.43-1.22-18.65-1.82.03-.28.05-.57.08-.85 6.29.61 12.58 1.23 18.87 1.84-.1.28-.2.56-.3.83Zm60.26-113.21c-20.59-1.87-41.18-3.75-61.78-5.62 0-.32-.01-.63-.02-.95 20.63 1.81 41.26 3.63 61.89 5.44l-.1 1.13h.01ZM1115.99 82c62.34 1.84 222.16.32 322.64 12.53-72.4-4.55-395.15-14.67-322.64-12.53Z'/%3e%3c/g%3e%3cdefs%3e%3clinearGradient id='b' x1='0' x2='2549.5' y1='400' y2='400' gradientUnits='userSpaceOnUse'%3e%3cstop  stop-opacity='0.1' /%3e%3cstop offset='1' stop-opacity='0'/%3e%3c/linearGradient%3e%3cclipPath id='a'%3e%3cpath fill='white' d='M0 0h1440v400H0z'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e")`;

  return {
    colors,
    shape: 'none',
    backgroundImage: `${pattern}, ${gradient}`,
    fontColor: '#f9f9f9',
  };
};

const colors = {
  home: ['#003E21'],
  documentation: ['#2E2178'],
  github: ['#626669'],
  apis: ['#3A3600'],
  tool: ['#EF4C3D'],
  dashboard: ['#442EE0'],
};

const defaultPageTheme = 'home';
const genPageThemes = () => {
  return {
    home: genPageTheme(colors.home),
    documentation: genPageTheme(colors.documentation),
    apis: genPageTheme(colors.apis),
    tool: genPageTheme(colors.tool),
    github: genPageTheme(colors.github, '#1a1a1b'),
    dashboard: genPageTheme(colors.dashboard),
    GroupYamlGenerator: genPageTheme(colors.dashboard),
    catalogVer2: genPageTheme(colors.dashboard),
    CatalogYamlGenerator: genPageTheme(colors.dashboard),
    PublishingUpdates: genPageTheme(colors.dashboard),
    CreateHub: genPageTheme(colors.dashboard),
  };
};
const darkThemePalette = themes.dark.getTheme('v5')?.palette as PaletteOptions;

export const customUnifiedDarkTheme: UnifiedTheme = createUnifiedTheme({
  fontFamily: 'Inter',
  palette: {
    ...darkThemePalette,
    navigation: {
      ...darkThemePalette.navigation,
      indicator: 'var(--xlrt-color-future-green500)',
      background: '#424242',
      navItem: {
        hoverBackground: '#4D4D4D;',
      },
    },
  } as Partial<PaletteOptions>,
  defaultPageTheme,
  pageTheme: genPageThemes(),
  components: {
    BackstageHeaderLabel: {
      styleOverrides: {
        value: {
          display: 'block',
        },
      },
    },
    // MuiCssBaseline: {
    //   styleOverrides: {
    //     '@font-face': [cariadFontRegular, cariadFontLight],
    //   },
    // },
    BackstageSidebarItem: {
      styleOverrides: {
        root: {
          textDecoration: 'none',
          '& .MuiSvgIcon-root': {
            fontSize: '1.25rem',
          },
        },
      },
    },
    BackstagePage: {
      styleOverrides: {
        root: {
          height: 'calc(100vh - 64px )',
        },
      },
    },
    BackstageSidebar: {
      styleOverrides: {
        drawer: {
          top: 'unset',
          height: 'calc(100vh - 64px)',
          borderRight: '1px solid var(--xlrt-color-ui-gray40)',
          '& hr': {
            background: '#383737',
          },
        },
      },
    },
    BackstageHeader: {
      styleOverrides: {
        header: {
          backgroundImage: 'none',
          background: 'var(--xlrt-color-ui-gray25)',
          boxShadow: 'none',
          padding: '16px',
          borderBottom: '1px solid var(--xlrt-color-ui-gray40)',
        },
        title: {
          color: '#FFF',
          fontSize: '24px',
        },
        subtitle: {
          color: 'var(--xlrt-color-ui-gray75)',
        },
      },
    },
    BackstageContent: {
      styleOverrides: {
        root: {
          background: 'var(--xlrt-color-ui-gray25)',
        },
      },
    },
  },
});

const lightThemePalette = themes.light.getTheme('v5')
  ?.palette as PaletteOptions;

export const customUnifiedLightTheme: UnifiedTheme = createUnifiedTheme({
  fontFamily: 'Inter',
  palette: {
    ...lightThemePalette,
    navigation: {
      ...lightThemePalette.navigation,
      background: '#FFF',
      selectedColor: '#222222',
      color: '#74757E',
      indicator: 'var(--xlrt-color-future-green500)',
      navItem: {
        hoverBackground: '#E9EBEC',
      },
    },
  } as Partial<PaletteOptions>,
  defaultPageTheme,
  pageTheme: genPageThemes(),
  components: {
    BackstageHeaderLabel: {
      styleOverrides: {
        label: {
          color: 'inherit',
        },
        value: {
          display: 'block',
          color: 'inherit',
        },
      },
    },
    // MuiCssBaseline: {
    //   styleOverrides: {
    //     '@font-face': [cariadFontRegular, cariadFontLight],
    //   },
    // },
    BackstageSidebarItem: {
      styleOverrides: {
        root: {
          textDecoration: 'none',
          '& .MuiSvgIcon-root': {
            fontSize: '1.25rem',
          },
        },
      },
    },
    BackstagePage: {
      styleOverrides: {
        root: {
          height: 'calc(100vh - 64px )',
        },
      },
    },
    BackstageSidebar: {
      styleOverrides: {
        drawer: {
          top: 'unset',
          height: 'calc(100vh - 64px)',
          borderRight: '1px solid #E1E3E5',
          '& hr': {
            background: '#E1E3E5',
          },
        },
      },
    },
    BackstageHeader: {
      styleOverrides: {
        header: {
          backgroundImage: 'none',
          background: '#FAFAFA',
          boxShadow: 'none',
          padding: '16px',
          borderBottom: '1px solid #E1E3E5',
        },
        title: {
          color: '#222',
          fontSize: '24px',
        },
        subtitle: {
          color: '#74757E',
        },
        type: {
          color: 'inherit',
        },
        rightItemsBox: {
          '& button': {
            color: 'inherit',
          },
        },
      },
    },
    BackstageContent: {
      styleOverrides: {
        root: {
          background: '#FAFAFA',
        },
      },
    },

    // PluginCatalogEntityContextMenu: {
    //   styleOverrides: {
    //     button: {
    //       color: 'inherit',
    //     },
    //   },
    // },
  },
});
